(() => {
  let deferredPrompt;
  const root = document.querySelector('[data-fs-install-root]');
  const button = document.querySelector('[data-fs-install-button]');
  const dialog = document.querySelector('[data-fs-install-dialog]');
  const steps = document.querySelector('[data-fs-install-steps]');
  if (!root || !button || !dialog || !steps) return;

  const mobile = window.matchMedia('(max-width: 749px) and (pointer: coarse)');
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const storageKey = 'farmsmart-install-seen-v1';
  const alreadySeen = () => {
    try { return localStorage.getItem(storageKey) === 'yes'; }
    catch { return false; }
  };
  const markSeen = () => {
    try { localStorage.setItem(storageKey, 'yes'); }
    catch { /* Storage can be unavailable in private browsing. */ }
  };
  const installed = () => window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
  const updateVisibility = () => {
    root.hidden = !mobile.matches || installed() || alreadySeen() || !(ios || deferredPrompt);
  };

  if (ios) button.textContent = 'Add FarmSmart to Home Screen';
  updateVisibility();
  mobile.addEventListener('change', updateVisibility);

  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    deferredPrompt = event;
    updateVisibility();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = undefined;
    markSeen();
    updateVisibility();
  });
  button.addEventListener('click', async () => {
    if (!mobile.matches || installed()) return;
    if (deferredPrompt) {
      const prompt = deferredPrompt;
      deferredPrompt = undefined;
      updateVisibility();
      await prompt.prompt();
      if (prompt.userChoice) {
        const choice = await prompt.userChoice;
        if (choice.outcome === 'accepted') markSeen();
      }
      return;
    }
    if (ios) {
      steps.textContent = 'In Safari, tap Share, then Add to Home Screen, then Add. On other iPhone browsers, use the browser Share menu to find Add to Home Screen.';
      markSeen();
      updateVisibility();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else alert(steps.textContent);
    }
  });
  dialog.querySelector('[data-fs-install-close]')?.addEventListener('click', () => dialog.close());
})();
